<template>
  <v-container fluid class="px-0">
    <div class="payroll-page">
      <v-row>
        <v-col cols="12" md="12">
          <v-card>
            <v-card-text>
              <v-row class="ma-1">
                <v-col cols="12" md="6">
                  <p class="text-h5 two-line">{{ initvalue.payrollname}}</p>
                  <p class="two-line">
                    {{ new Date(initvalue.payrollstartdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }} -
                    {{ new Date(initvalue.payrollenddate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
                  </p>
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="12" md="6" align="right">
                  <v-btn @click="$router.replace({ name: 'PayrollList' })" color="primary" text>
                <v-icon class="mr-2">mdi-check</v-icon>
                Done
                </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12" cols="12" class="pt-0 pt-sm-3">
          <v-row>
            <v-col cols="12">
              <v-card class="folder-card ma-1" min-height="282">
                <v-card-text class="pa-5 pt-0">

                  <v-tabs color="secondary">
                    <v-tabs-slider></v-tabs-slider>
                    <v-tab
                      ref="filesTab"
                      class="text-capitalize font-weight-regular"
                      :key="1"
                      :href="'#tab-statements'"
                    >
                      Statements
                    </v-tab>
                    <v-tab
                      ref="filesTab"
                      class="text-capitalize font-weight-regular"
                      :key="2"
                      :href="'#tab-files'"
                    >
                      Files
                    </v-tab>
                    <v-tab
                      class="text-capitalize font-weight-regular"
                      :key="3"
                      :href="'#tab-images'"
                    >
                      Images
                    </v-tab>
                    <v-tab-item
                      :key="1"
                      :value="'tab-statements'"
                      class="pb-0 pb-sm-3 pb-lg-0"
                    >
                      <v-divider></v-divider>
                      <v-row
                        justify-xl="space-around"
                        justify="start"
                        class="d-flex flex-nowrap overflow-x-auto pa-4 pt-5"
                      >
                        <v-col cols="12" md="12" sm="12">
                          <v-data-table
                            :loading="isReceiving || isDeleting"
                            loading-text="Loading... Please wait"
                            class="paystatements-table"
                            show-select
                            single-select
                            item-key="_id"
                            sort-desc
                            sort-by="paystatementnum"
                            :footer-props="footer"
                            :headers="headers"
                            :items="statementsData"
                            :items-per-page="itemPerPage">
                            <template v-slot:item.employeeid="{ item }">
                              <v-avatar v-if="employees.length>0" size="40">
                                <img v-bind:src="employees.find(employee=>employee._id == item.employeeid)['employeeimage']" alt="">
                              </v-avatar>
                              <v-avatar
                                v-else
                                color="warning"
                                size="40">
                                <span class="white--text headline">{{ employees>0 ? employees.find(employee=>employee._id == item.employeeid)['employeename'][0].toUpperCase() : ''}}</span>
                              </v-avatar>
                              <span style="margin-left:15px">{{ item.paystatementname }} </span>
                            </template>
                            <template v-slot:item.paystatementnum="{ item }">
                              <p class="two-line">{{ item.paystatementtype  }}</p>
                              <p class="two-line">{{ item.paystatementnum  }}</p>
                            </template>
                            <template v-slot:item.paystatementaddress="{ item }">
                              <p class="two-line">{{ item.paystatementaddress }}</p>
                            </template>
                            <template v-slot:item.paystatementstatus="{ item }">
                              <v-chip
                                :color="item.paystatementstatus=='New' ? 'primaryConst white--text' : item.paystatementstatus=='Pending' ? 'warning white--text' : item.paystatementstatus=='Complete' ? 'successConst white--text' : 'secondaryConst white--text'"
                                small>
                                {{ item.paystatementstatus }}
                              </v-chip>
                            </template>
                            <template v-slot:item.paystatementdate="{ item }">
                              {{ new Date(item.paystatementdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
                            </template>
                            <template v-slot:item.paystatementnetpay="{ item }">
                              {{ item.paystatementnetpay!=null ? item.paystatementnetpay.toLocaleString('en-SG') : '' }}
                            </template>
                            <template v-slot:item.createdAt="{ item }">
                              {{ new Date(item.createdAt).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
                            </template>
                            <template v-slot:item.actions="{ item }">
                              <v-btn icon color="primary" @click="printItem(item)">
                                <v-icon>mdi-printer</v-icon>
                              </v-btn>
                            </template>
                          </v-data-table>
                        </v-col>
                      </v-row>
                    </v-tab-item>
                    <v-tab-item
                      :key="2"
                      :value="'tab-files'"
                      class="pb-0 pb-sm-3 pb-lg-0"
                    >
                      <v-divider></v-divider>
                      <v-row
                        justify-xl="space-around"
                        justify="start"
                        class="d-flex flex-nowrap overflow-x-auto pa-4 pt-5"
                      >
                        <v-col cols="12" md="12" sm="12">
                          <v-data-table
                            :headers="fileHeaders"
                            :items="files"
                            :items-per-page="100"
                            class="elevation-0"
                          >
                            <template v-slot:item.filetype="{ item }">
                              <a
                                v-if="item.filetype == 'pdf'"
                                :href="item.fileurl"
                                style="text-decoration: none !important"
                              >
                                <v-icon size="50" color="primary">
                                  mdi-file-pdf-box
                                </v-icon></a
                              >
                            </template>
                            <template v-slot:item.filesize="{ item }">
                              {{ (item.filesize / 1000).toFixed(0) + " KB" }}
                            </template>
                            <template v-slot:item.createdAt="{ item }">
                              {{
                                new Date(item.createdAt).toLocaleString(
                                  "en-SG",
                                  {
                                    year: "numeric",
                                    month: "numeric",
                                    day: "numeric",
                                  }
                                )
                              }}
                            </template>
                        <template v-slot:item.actions="{ item }">
                          <v-btn
                            icon
                            color="primary"
                            @click="previewFile(item)"
                          >
                            <v-icon>mdi-text-box-search</v-icon>
                          </v-btn>
                        </template>
                          </v-data-table>
                        </v-col>
                      </v-row>
                    </v-tab-item>
                  </v-tabs>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <v-row> </v-row>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import config from "@/config";
import { mapState, mapActions } from 'vuex'

export default {
  name: "Profile",

  data() {
    return {
      config,
      initvalue: {},
      transactions: [],
      files: [],
      statementsData: [],
      selectedTab: "1",
      headers: [
        { text: 'Num', value: 'paystatementnum' },
        { text: 'Date', value: 'paystatementdate' },
        { text: 'Employee', value: 'employeeid' },
        { text: 'Net Pay', value: 'paystatementnetpay' },
        { text: 'Status', value: 'paystatementstatus' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      fileHeaders: [
        { text: "Type", value: "filetype" },
        { text: "Name", value: "filename" },
        { text: "Size", value: "filesize" },
        { text: "Created", value: "createdAt" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      footer: {'items-per-page-options': [100, 500, 1000, 5000]},
      itemPerPage: 100,
      selected: [],
    };
  },
  computed: {
    ...mapState('Employee', ['employees']),
    ...mapState('PayStatement', ['isReceiving', 'isDeleting', 'isUpdating']),
  },
  methods: {
    ...mapActions('Employee', ["getEmployeesRequest"]),
    ...mapActions("File", ["getPayrollFiles"]),
    ...mapActions('PayStatement', ["getPayStatementsByPayroll"]),
    previewFile(item){
      let params = Object.assign({}, this.initvalue);
      params.fileurl = item.fileurl;
      params.isFromPayroll = true;
      this.$router.push({ name: "FilePreview", params: params })
    },
    printItem(item) {
      item.payload = this.initvalue;
      item.isFromPayroll = true;
      this.$router.push({ name: 'PayStatementPrint', params: item})
    },
  },
  async created() {
    this.initvalue = this.$route.params;    
    if (!this.initvalue._id) this.$router.push({ name: "PayrollList" });
    this.statementsData = await this.getPayStatementsByPayroll(this.initvalue._id);
    this.files = await this.getPayrollFiles(this.initvalue._id);
    if(this.employees.length==0) await this.getEmployeesRequest();
    if(this.initvalue.isFromFiles==true) {this.$refs.filesTab.$el.click()}
  },
};
</script>

<style src="./View.scss" lang="scss"/>
